<h1>Landholder Contact Details</h1>

<form [formGroup]="form" class="form">
  @if (nextButtonClicked) {
    <app-global-validation-message [formInput]="form"> </app-global-validation-message>
  }

  <ol class="questions">
    <li class="group">
      <ol class="questions">
        <li>
          <label for="firstName"> <span class="label">First name</span> <abbr title="(required)"
        class="required">*</abbr>
        @if ((nextButtonClicked || firstNameControl.dirty) && firstNameControl.errors != null) {
          <em class="red-alert"
            >
            First name is required
          </em>
        }
      </label>
      <input type="text" maxlength="255" formControlName="firstName" id="firstName"
        [ngClass]="{'col-md-8': true, 'error': (nextButtonClicked || firstNameControl.dirty) && firstNameControl.errors != null}"/>
      </li>
      <li>
        <label for="middleName">
          <span class="label">Middle name</span>
        </label>
        <input type="text" class="col-md-8" formControlName="middleName" id="middleName"/>
      </li>
      <li class="required">
        <label for="lastName">
          <span class="label">Last name</span>
          <abbr title="(required)" class="required">*</abbr>
          @if ((nextButtonClicked || lastNameControl.dirty) && lastNameControl.errors != null) {
            <em class="red-alert"
              >
              Last name is required
            </em>
          }
        </label>
        <input type="text" formControlName="lastName" maxlength="255" id="lastName"
          [ngClass]="{'col-md-8': true, 'error': (nextButtonClicked || lastNameControl.dirty) && lastNameControl.errors != null}"/>
        </li>
        <li>
          <label for="companyName">
            <span class="label">Company name</span>
          </label>
          <input type="text" formControlName="companyName" name="companyName" maxlength="255" class="col-md-8"
            id="companyName"/>
          </li>
          <li class="group phoneGroup">
            <label>
              <abbr title="(required)" required class="required">*</abbr>
              @if (phoneControl.dirty && phoneControl.errors != null) {
                <em class="red-alert" >
                  Phone is not valid
                </em>
              }
              @if (mobileControl.dirty && mobileControl.errors != null) {
                <em class="red-alert">
                  Mobile is not valid
                </em>
              }
              @if ((nextButtonClicked || phoneControl.dirty || mobileControl.dirty) && !phoneControl.value && !mobileControl.value) {
                <em class="red-alert">
                  Phone or Mobile is required
                </em>
              }
            </label>
            <ol class="questions compact">
              <li>
                <label for="phone">
                  <span class="label">Phone</span>
                </label>
                <input type="tel" formControlName="phone" maxlength="26" class="col-md-8" id="phone" />
              </li>
              <li>
                <label for="mobile">
                  <span class="label">Mobile</span>
                </label>
                <input type="tel" formControlName="mobile" maxlength="26" class="col-md-8" id="mobile" />
              </li>
            </ol>
          </li>
          <li class="required">
            <label for="email">
              <span class="label">Email</span>
              <abbr title="(required)" class="required">*</abbr>
              @if ((nextButtonClicked || emailControl.dirty) && emailControl.errors != null) {
                <em class="red-alert">
                  Email is required
                </em>
              }
            </label>
            <input type="text" formControlName="email" maxlength="200" id="email"
              [ngClass]="{'col-md-8': true, 'error': (nextButtonClicked || emailControl.dirty) && emailControl.errors != null}"/>
            </li>
          </ol>
        </li>

        <li class="group">
          <legend>
            <h4>Home address</h4>
          </legend>
          <ol class="questions">
            <li class="required">
              <label for="homeAddressLine1">
                <span class="label">Address line 1</span>
                <abbr title="(required)" class="required">*</abbr>
                @if ((nextButtonClicked || homeAddressLine1Control.dirty) && homeAddressLine1Control.errors != null) {
                  <em class="red-alert">
                    Address is required
                  </em>
                }
              </label>
              <input type="text" formControlName="homeAddressLine1" maxlength="100" id="homeAddressLine1"
                [ngClass]="{'col-md-8': true, 'error': (nextButtonClicked || homeAddressLine1Control.dirty) && homeAddressLine1Control.errors != null}"/>
              </li>
              <li>
                <label for="homeAddressLine2">
                  <span class="label">Address line 2</span>
                </label>
                <input type="text" formControlName="homeAddressLine2" maxlength="100" class="col-md-8"
                  id="homeAddressLine2" />
                </li>
                <li class="group">
                  <ol class="questions compact">
                    <li class="required">
                      <label for="homeAddressSuburb">
                        <span class="label">Town/Suburb</span>
                        <abbr title="(required)" class="required">*</abbr>
                        @if ((nextButtonClicked || homeAddressSuburbControl.dirty)&& homeAddressSuburbControl.errors != null) {
                          <em class="red-alert">
                            Town/Suburb is required
                          </em>
                        }
                      </label>
                      <input type="text" formControlName="homeAddressSuburb" maxlength="100" id="homeAddressSuburb"
                        [ngClass]="{'col-md-8': true, 'error': (nextButtonClicked || homeAddressSuburbControl.dirty) && homeAddressSuburbControl.errors != null}"/>
                      </li>
                      <li class="required">
                        <label for="homeAddressPostcode">
                          <span class="label">Postcode</span>
                          <abbr title="(required)" class="required">*</abbr>
                          @if ((nextButtonClicked || homeAddressPostcodeControl.dirty) && homeAddressPostcodeControl.errors != null) {
                            <em class="red-alert">
                              Postcode must be 4 characters
                            </em>
                          }
                        </label>
                        <input type="text" inputmode="numeric" formControlName="homeAddressPostcode" id="homeAddressPostcode" (keypress)="formatPostCode($event)"
                          maxlength="4" [ngClass]="{'col-md-8': true, 'error': (nextButtonClicked || homeAddressPostcodeControl.dirty) && homeAddressPostcodeControl.errors != null}"/>
                        </li>
                      </ol>
                    </li>
                    <li>
                      <label for="homeAddressStateId">
                        <span class="label">State</span>
                      </label>
                      <select formControlName="homeAddressStateId" id="homeAddressStateId">
                        @for (state of this.states; track state) {
                          <option [value]="state.id">
                            {{state.name}}
                          </option>
                        }
                      </select>
                      <br>
                      </li>
                      <li class="group">
                        <legend>
                          <h4>Mailing address</h4>
                          <input type="checkbox" id="mailingAddressSameAsPhysicalAddress"
                            formControlName="mailingAddressSameAsPhysicalAddress" />
                            <label for="mailingAddressSameAsPhysicalAddress">Same as home address</label>
                          </legend>

                        @if (!mailingAddressSameAsPhysicalAddressControl.value) {
                            <ol class="questions">
                              <li class="required">
                                <label for="mailingAddressLine1">
                                  <span class="label">Address line 1</span>
                                  <abbr title="(required)" class="required">*</abbr>
                                  @if ((nextButtonClicked || mailingAddressLine1Control.dirty)  && mailingAddressLine1Control.errors != null) {
                                    <em class="red-alert">
                                      Address is required
                                    </em>
                                  }
                                </label>
                                <input type="text" formControlName="mailingAddressLine1" maxlength="100" id="mailingAddressLine1"
                                  [ngClass]="{'col-md-8': true, 'error': (nextButtonClicked || mailingAddressLine1Control.dirty) && mailingAddressLine1Control.errors != null}"/>
                                </li>
                                <li>
                                  <label for="mailingAddressLine2">
                                    <span class="label">Address line 2</span>
                                  </label>
                                  <input type="text" formControlName="mailingAddressLine2" maxlength="100" class="col-md-8"
                                    id="mailingAddressLine2" />
                                  </li>
                                  <li class="group">
                                    <ol class="questions compact">
                                      <li class="required">
                                        <label for="mailingAddressSuburb">
                                          <span class="label">Town/Suburb</span>
                                          <abbr title="(required)" class="required">*</abbr>
                                          @if ((nextButtonClicked || mailingAddressSuburbControl.dirty) && mailingAddressSuburbControl.errors != null) {
                                            <em class="red-alert">
                                              Town/Suburb is required
                                            </em>
                                          }
                                        </label>
                                        <input type="text" id="mailingAddressSuburb" maxlength="100" formControlName="mailingAddressSuburb"
                                          [ngClass]="{'col-md-8': true, 'error': (nextButtonClicked || mailingAddressSuburbControl.dirty) && mailingAddressSuburbControl.errors != null}"/>
                                        </li>
                                        <li class="required">
                                          <label for="mailingAddressPostcode">
                                            <span class="label">Postcode</span>
                                            <abbr title="(required)" class="required">*</abbr>
                                            @if ((nextButtonClicked || mailingAddressPostcodeControl.dirty) && mailingAddressPostcodeControl.errors != null) {
                                              <em class="red-alert"
                                                >
                                                Postcode must be 4 characters
                                              </em>
                                            }
                                          </label>
                                          <input type="text" inputmode="numeric" formControlName="mailingAddressPostcode" id="mailingAddressPostcode" (keypress)="formatPostCode($event)"
                                            maxlength="4" [ngClass]="{'col-md-8': true, 'error': (nextButtonClicked || mailingAddressPostcodeControl.dirty) && mailingAddressPostcodeControl.errors != null}">
                                          </li>
                                        </ol>
                                      </li>
                                      <li>
                                        <label for="mailingAddressStateId">
                                          <span class="label">State</span>
                                        </label>
                                        <select formControlName="mailingAddressStateId" id="mailingAddressStateId">
                                          @for (state of this.states; track state) {
                                            <option [value]="state.id">
                                              {{state.name}}
                                            </option>
                                          }
                                        </select>
                                      </li>
                                    </ol>
                                  }
                                </li>
                              </ol>
                            </li>
                          </ol>
                          <li class="footer">
                            <ul class="actions">
                              <li> <input class="qg-btn btn-global-secondary" type="submit" (click)="previous()" value="Previous" /> </li>
                              <li> <em> <input class="qg-btn btn-primary" type="submit" (click)="next()" value="Next" /> </em> </li>
                            </ul>
                            <ul class="actions">
                              <li>
                                <a href (click)="cancel()">Cancel</a>
                              </li>
                            </ul>
                          </li>
                        </form>
